import { render, staticRenderFns } from "./GameMaker.vue?vue&type=template&id=fd7f0ece&scoped=true&"
import script from "./GameMaker.vue?vue&type=script&lang=js&"
export * from "./GameMaker.vue?vue&type=script&lang=js&"
import style0 from "./GameMaker.vue?vue&type=style&index=0&id=fd7f0ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7f0ece",
  null
  
)

export default component.exports